"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=14271%3A236))
 * @trackcomponent
 * @lastsynced 2026-09-30T17:16:17.000Z
 * @optimized using svgo:^3.3.4
 */
export const BSREdit = createSVGIcon(
  <path
    d="M12.991 2.746H2.751v18.5h18.5V11.005M6.823 13.54l-.412 4.043 4.044-.411L21.25 6.378l-3.632-3.632z"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
  />,
  "BSREdit",
  (strictLocalize) => ({
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    titleAccess: strictLocalize({
      id: "jlb8/p",
      defaultMessage: "Edit",
      description: {
        text: "Message for screenreaders when only the icon is displayed",
      },
    }),
    viewBox: "0 0 24 24",
  })
);
